import { render } from "./icon-button.vue?vue&type=template&id=28f73aa6&lang=pug"
import script from "./icon-button.vue?vue&type=script&lang=js"
export * from "./icon-button.vue?vue&type=script&lang=js"
script.render = render

export default script